import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HomeAway } from 'src/app/models/enums';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { IScoreGroup } from 'src/app/models/results/scoreGroup.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { EventsService } from 'src/app/services/events.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { LocaleHelper } from 'src/locale/LocaleHelper';

@Component({
  selector: 'app-results-event',
  templateUrl: './results-event.component.html',
  styleUrls: ['./results-event.component.less']
})
export class ResultsEventComponent implements OnInit, OnDestroy {

  arr = Array;
  private language: string;
  languageForBetradar: string;

  dynamicTranslations = DynamicTranslations;
  scrollY: number;
  mobileScrollContent = document.getElementsByClassName('content-wrap')[0];

  private subscription: Subscription = new Subscription();


  @Input()
  scoreGroups: IScoreGroup[];

  @Input()
  eventResult: IEventResult;


  viewConfigurations = ViewConfigurations;

  enumsHomeAway = HomeAway;

  constructor(
    private eventsService: EventsService,
    private storage: StorageService,
    private utilityService: UtilityService
  ) {
    this.language = storage.language;
    this.languageForBetradar = LocaleHelper.languageForBetradar[this.language];

    this.subscription.add(this.eventsService.expandedEvent$.subscribe((ev) => {
      if (!ev && this.scrollY) {
        setTimeout(() => {
          if (utilityService.mobileView && this.mobileScrollContent) {
            this.mobileScrollContent.scroll(0, this.scrollY);
          } else {
            window.parent.scroll(0, this.scrollY);
          }
          this.scrollY = null;
        }, 100);
      }
    }));
  }

  ngOnInit(): void {
    const a = this.eventResult;

  }

  showDetail(eventResult: IEventResult) {
    this.eventsService.expandEventResult(eventResult);
    if (this.utilityService.mobileView && this.mobileScrollContent) {
      this.scrollY = this.mobileScrollContent.scrollTop;
    } else {
      this.scrollY = window.parent.scrollY;
    }
    window.parent.scroll(0, 0);
  }


  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
